<template>
  <router-view></router-view>
</template>

<script>
export default {
  name:"AppRoot"
}
</script>



// WEBPACK FOOTER //
// src/App.vue